import React, { Fragment, useEffect, useState } from "react";
import Tippy from "@tippyjs/react";

const ActionsDropdown = ({
    row,
    subRow,
    attributes,
    selected,
    appendTo = ".table-responsive",
    entity = "",
}) => {
    const [visible, setVisible] = useState(false);
    const show = () => setVisible(true);
    const hide = () => setVisible(false);
    const toggle = (e) => {
        e.stopPropagation();
        setVisible((prevVal) => !prevVal);
    };

    useEffect(() => {
        if (subRow && selected?.id === row?.id) {
            show();
        } else {
            hide();
        }
    }, [selected]);

    const handelClick = (attribute) => {
        hide();
        if (subRow) {
            attribute.handler(subRow, row);
        } else {
            attribute.handler(row);
        }
    };

    const renderAttributes = () => {
        return (
            attributes &&
            attributes.map((attribute, key) => {
                if (attribute.authorized) {
                    return (
                        <Fragment key={key}>
                            {attribute.includeHorizontalLine && <hr />}
                            <button
                                disabled={
                                    attribute.isDisabled &&
                                    attribute.isDisabled(subRow?.status)
                                }
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handelClick(attribute);
                                }}
                                id={`${
                                    entity && `${entity}-`
                                }actions-dropdown-btn-${key}`}
                            >
                                <span
                                    className={
                                        (attribute.color &&
                                            `color-${attribute.color}`) ||
                                        ""
                                    }
                                >
                                    <i
                                        className={`${attribute.icon} mr-2 fa-sm`}
                                    />
                                    {attribute.name}
                                </span>
                            </button>
                        </Fragment>
                    );
                }
            })
        );
    };

    return (
        <Tippy
            visible={visible}
            content={renderAttributes()}
            onClickOutside={hide}
            theme="light-border"
            interactive="true"
            placement="left"
            appendTo={() => document.querySelector(appendTo)}
        >
            <span
                className="p-2 cursor-pointer"
                onClick={toggle}
                id={`actions-dropdown${entity && `-${entity}`}`}
            >
                <i className="fas fa-ellipsis-v ellipse-icon-btn text-gray-500" />
            </span>
        </Tippy>
    );
};

export default ActionsDropdown;
